import React from "react";
import NavBar from "../Components/Navigation/NavBar.js";
import { Container } from "@mui/material";
import { Route, Routes } from "react-router";
import Home from "../Pages/Home.js";
import Projects from "../Pages/Projects/Projects.js";
import Clients from "../Pages/Clients/Clients.js";
import Products from "../Pages/Products/Products.js";
import CreateProject from "../Pages/Projects/CreateProject.js";
import CreateClient from "../Pages/Clients/CreateClient.js";
import CreateProduct from "../Pages/Products/CreateProduct.js";
import ProjectDetails from "../Pages/Projects/ProjectDetails";
import EditProject from "../Pages/Projects/EditProject";
import NotFound from "../Components/Error/NotFound";
import ProductDetails from "../Pages/Products/ProductDetails";
import ClientDetails from "../Pages/Clients/ClientDetails";
import Onboarding from "../Pages/Onboarding";
import RequiresOnboarding from "../Components/User/RequiresOnboarding";
import { useTheme } from "@mui/material/styles";
import ManageParameters from "../Pages/Management/ManageParameters";
import ManageTemplates from "../Pages/Management/ManageTemplates";
import ManageCategories from "../Pages/Management/ManageCategories";

export const PageLayout = () => {
	const theme = useTheme();
	return (
		<div
			className='App'
			style={{ backgroundColor: theme.palette.lightGrey.main }}
		>
			<Routes>
				<Route
					path='/onboarding'
					element={<Onboarding />}
				/>
				<Route element={<RequiresOnboarding />}>
					<Route
						path='*'
						element={
							<React.Fragment>
								<NavBar />
								<Container sx={{ my: 15 }}>
									<Routes>
										<Route
											path='/'
											element={<Home />}
										/>
										<Route
											path='/projects'
											element={<Projects />}
										/>
										<Route
											path='/projects/new'
											element={<CreateProject />}
										/>
										<Route
											path='/clients'
											element={<Clients />}
										/>
										<Route
											path='/clients/new'
											element={<CreateClient />}
										/>
										<Route
											path='/products'
											element={<Products />}
										/>
										<Route
											path='/products/new'
											element={<CreateProduct />}
										/>
										<Route
											path='/projects/:id'
											element={<ProjectDetails />}
										/>
										<Route
											path='/products/:id'
											element={<ProductDetails />}
										/>
										<Route
											path='/clients/:id'
											element={<ClientDetails />}
										/>
										<Route
											path='/projects/:id/edit'
											element={<EditProject />}
										/>
										<Route
											path='/management/parameters'
											element={<ManageParameters />}
										/>
										<Route
											path='/management/categories'
											element={<ManageCategories />}
										/>
                                        <Route 
                                            path='/management/templates'
                                            element={<ManageTemplates />} 
                                        />
										<Route
											path='*'
											element={<NotFound />}
										/>
									</Routes>
								</Container>
							</React.Fragment>
						}
					/>
				</Route>
			</Routes>
		</div>
	);
};
